import React from "react";
import Modal from "react-modal";
import { postArchiveNotification, postReadNotification } from "../../services";
import * as s from "./styles";
import { notifyError, notifySuccess } from '../../utils';

const ArchivalConfirmation = ({ openModal, setOpenModal, event, buscaNotificacoes }) => (
    <Modal 
      isOpen={openModal}
      onRequestClose={() => setOpenModal(false)}
      ariaHideApp={false}
      style={s.modalStyle}
    >
      <s.Container>
        <s.CloseButton onClick={() => setOpenModal(false)}>X</s.CloseButton>

        <label>Deseja arquivar essa notificação?</label>
        
        <s.ButtonWrapper>
          <s.ArchiveButton
            onClick={() => {
              postArchiveNotification({ eventId: event.id })
                .then(() => {
                  notifySuccess('Arquivado com sucesso');
                  buscaNotificacoes();
                })
                .catch(() => {
                  notifyError('Não foi possivel arquivar a notificação');
                });
              postReadNotification({ eventId: event.id });
              setOpenModal(false);
            }}
          >
            Arquivar
          </s.ArchiveButton>

          <s.CancelButton
            onClick={() => setOpenModal(false)}
          >
            Cancelar
          </s.CancelButton>
        </s.ButtonWrapper>
      </s.Container>
    </Modal>
  );

export default ArchivalConfirmation;
